import React from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import PropTypes from "prop-types";

export default function MonthYearPicker({
   disable= false,
  error= false,
  errorMessage= "",
  label= "",
  maxDate= "",
  minDate= "",
  onChange= () => {},
  placeholder= "mm/yyyy",
  value= "",
}) {
  const month = value?.split("/")[0];
  const year = value?.split("/")[1];
  const getValue = new DateObject()
    .setMonth(month || "")
    .setYear(year || "");

  return (
    <div>
      <div className="frmhead">
        {label && <label>{label}</label>}
        {error && <div className="error">{errorMessage}</div>}
      </div>
      <DatePicker
        render={
          <InputIcon
            className={error ? "rmdp-input errortag" : "rmdp-input"}
            placeholder="mm/yyyy"
            disabled={disable}
            readOnly
          />
        }
        onlyMonthPicker
        placeholder={placeholder || "mm/yyyy"}
        value={getValue}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disable}
      />
    </div>
  );
}

MonthYearPicker.propTypes = {
  disable: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.string,
  maxDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
    PropTypes.object,
  ]),
  minDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
    PropTypes.object,
  ]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};



